<template>
  <div class="business">
    <div class="flex-left">
      <h2>业务范围遍及全国</h2>
      <el-row :gutter="20">
        <el-col :span="6" v-for="item in cityData" :key="item.id"
          ><span class="grid-content bg-purple" @click="Aitem(item.name)">{{
            item.name
          }}</span></el-col
        >
      </el-row>
      <div class="icons">
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'city' }
          }"
        >
          <div class="mt-20">
            <img src="@image/btnIcon.png" alt="" />
            <div class="cityMsg">
              <span class="num"> {{ homeData.city }}</span>
              <span class="msg">个省市</span>
            </div>
          </div>
        </router-link>
        <router-link
          :to="{
            name: ylStatus ? 'business_yl' : 'business',
            query: { routerPath: 'city' }
          }"
        >
          <!-- <img src="@image/cityIcon2.png" alt="" class="mt-20" /> -->
          <div class="mt-20">
            <img src="@image/btnIcon.png" alt="" />
            <div class="cityMsg">
              <span class="num">{{ cityNum }}</span>
              <span class="msg">家子公司</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="flex-right">
      <div
        id="myChartChina"
        :style="{ minWidth: '600px', height: '500px' }"
        class="map"
      ></div>
    </div>
  </div>
</template>

<script>
import dataList from '@/views/businessWork/company.js'
import { getBusiness } from '@/api/sale'
export default {
  name: 'Business',
  components: {},
  data() {
    return {
      cityData: [],
      provinceData: [],
      ylStatus: this.$store.getters.urlStatus,
      cityNum: ''
    }
  },
  computed: {
    homeData() {
      let data = this.$store.getters.homeData
      let num = {}
      if (data) {
        for (const key in data) {
          switch (data[key].sign) {
            case 'syhzcj':
              num.plant = data[key].content
              break
            case 'syhzjxs':
              num.saleNum = data[key].content
              break
            case 'sysssl':
              num.city = data[key].content
              break
          }
        }
      }
      return num
    }
  },
  mounted() {},
  created() {
    this.getCity()
  },
  methods: {
    // 业务范围
    getCity() {
      getBusiness()
        .then(res => {
          let data = res.data
          this.cityNum = res.msg
          let province = dataList.data.province
          province.forEach(item => {
            data.forEach(it => {
              if (item.name == it.name) {
                item.value = this.randomData()
                if (it.address && it.address.length > 20) {
                  item.address =
                    it.address.slice(0, 20) +
                    '<br>' +
                    it.address.slice(20, it.address.length)
                } else {
                  item.address = it.address
                }
                item.companyName = it.companyName
                item.id = it.id
                item.tel = it.tel
                item.img = it.img
                item.img = it.img
                if (it.children) {
                  it.children.forEach(v => {
                    if (v.address && v.address.length > 20) {
                      v.address =
                        v.address.slice(0, 20) +
                        '<br>' +
                        v.address.slice(20, v.address.length)
                    } else {
                      v.address = v.address
                    }
                  })
                  item.children = it.children
                }
              }
            })
          })

          this.provinceData = province
          this.cityData = data
          this.drawLine()
        })
        .catch(err => {
          console.log(err)
        })
    },
    Aitem(name) {
      this.$router.push({
        path: this.ylStatus ? '/business_yl' : '/business',
        query: { routerPath: 'city', cityName: name }
      })
    },
    // 随机数
    randomData() {
      return Math.round(Math.random() * 500)
    },
    // Aitem(name) {
    //   var myChartContainer = document.getElementById('myChartChina')
    //   var myChartChina = this.$echarts.init(myChartContainer)
    //   myChartChina.dispatchAction({
    //     //禁止高亮在使用map展示信息时（点击下一个城市后取消掉上一个城市的高亮）

    //     type: 'downplay'
    //   })
    //   myChartChina.dispatchAction({
    //     type: 'hideTip'
    //   })

    //   myChartChina.dispatchAction({
    //     //在地图中高亮选择的城市
    //     type: 'highlight',
    //     name: name
    //   })
    //   myChartChina.dispatchAction({
    //     type: 'showTip',
    //     seriesIndex: 0,
    //     name: name
    //   })
    // },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      var myChartContainer = document.getElementById('myChartChina')
      var resizeMyChartContainer = function() {
        myChartContainer.style.width = document.body.offsetWidth / 2 + 'px' //页面一半的大小
      }
      resizeMyChartContainer()
      var myChartChina = this.$echarts.init(myChartContainer)
      // 绘制图表
      var optionMap = {
        tooltip: {
          //此处是根据后端数据进行hover 展示的提示框，可用官网上默认的
          trigger: 'item',
          backgroundColor: '#fff', //设置背景图片
          color: 'black',
          position: 'left',
          textStyle: {
            color: '#666666' //设置文字颜色
          },
          formatter: function(params) {
            if (params.data.companyName) {
              return (
                '<div style="font-size:10px;text-align: start; text-align: initial;float:left;margin-right:8px"><img style="width:220px;height:150px;box-shadow: 0px 4px 30px 0px rgba(25, 49, 80, 0.07);"  src="' +
                params.data.img +
                '" /><div><h3 style="font-size:14px;font-weight: 500;color:#343434">' +
                params.data.companyName +
                '</h3><div>电话：</div><div>' +
                params.data.tel +
                '</div><div>地址：</div><div style="width:200px;word-break: break-word">' +
                params.data.address +
                '</div></div></div>'
              )
            } else {
              if (params.data.children) {
                let data = params.data.children
                let htmlDom = ''
                data.map(item => {
                  htmlDom +=
                    '<div style="font-size:10px;text-align: start; text-align: initial;float:left;margin-right:8px"><img style="width:220px;height:150px;" src="' +
                    item.img +
                    '" /><div><h3 style="font-size:14px;font-weight: 500;color:#343434">' +
                    item.companyName +
                    '</h3><div>电话：</div><div>' +
                    item.tel +
                    '</div><div>地址：</div><p style="word-break: break-word">' +
                    item.address +
                    '</p></div></div>'
                })
                return htmlDom
              } else {
                return '暂未开通'
              }
            }
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['']
        },
        series: [
          {
            name: '',
            type: 'map',
            mapType: 'china',
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 0.2)',
                color: 'rgba(13,126,248,1)'
              },
              emphasis: {
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            showLegendSymbol: true,
            label: {
              normal: {
                show: true
              },
              emphasis: {
                show: true
              }
            },
            data: this.provinceData
          }
        ]
      }

      myChartChina.setOption(optionMap)
      window.onresize = function() {
        resizeMyChartContainer()
        myChartChina.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.business {
  display: flex;
  width: 75%;
  margin: auto;
  height: 450px;
  padding: 100px;
  background: #fff;
  .flex-left {
    margin-left: 150px;
    h2 {
      text-align: start;
      text-align: initial;
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
    }
    .el-row {
      margin-top: 50px;
      width: 400px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(32, 32, 32, 1);
      .el-col {
        padding-bottom: 10px;
        text-align: start;
        text-align: initial;
        width: 100px;
        cursor: pointer;
      }
    }
    .icons {
      width: 163px;
      .mt-20 {
        position: relative;
        .cityMsg {
          position: absolute;
          bottom: 0px;
          left: 40px;
          color: rgba(255, 255, 255, 1);
          line-height: 45px;
          .num {
            font-size: 24px;
            font-weight: 400;
          }
        }
      }
      img {
        display: block;
      }
    }
  }
  .map {
    margin: -20px;
  }
}
</style>
